<ng-container *ngIf="hasContentBlock(slug)">
  <div *ngIf="getContentBlock(slug).type == 'text/plain'">
    {{ getContentBlock(slug).content }}
  </div>
  <div *ngIf="getContentBlock(slug).type == 'text/html'" [innerHTML]="getContentBlock(slug).content"></div>
</ng-container>
